import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const SearchableSelectDefaultProps = {
  ...ClassNameDefaultProps,
  className: null,
  children: null,
  data: null,
  disabled: false,
  errors: null,
  errorsIcon: null,
  id: null,
  name: '',
  position: 'top',
  readOnly: false,
  required: false,
  onChange: () => {},
};

export const SearchableSelectPropTypes = {
  ...ClassNamePropTypes,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  disabled: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  errorsIcon: PropTypes.element,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  position: PropTypes.oneOf(['top', 'right', 'left']),
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
};
